import { render } from "./AccountBenefitList.vue?vue&type=template&id=70d79aa5"
import script from "./AccountBenefitList.vue?vue&type=script&lang=js"
export * from "./AccountBenefitList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__